/**
 * View component for /course-certificates/:courseCertificateId/update
 *
 * Updates a single courseCertificate from a copy of the selcted courseCertificate
 * as defined in the courseCertificate reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as courseCertificateActions from '../courseCertificateActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import CourseCertificateForm from '../components/CourseCertificateForm.js.jsx';
import CourseCertificateLayout from '../components/CourseCertificateLayout.js.jsx';

// import courseCertificate css modules
import courseCertificateStyles from '../courseCertificateModuleStyles.css';

class UpdateCourseCertificate extends Base {
  constructor(props) {
    super(props);
    const { selectedCourseCertificate, courseCertificateMap } = this.props;
    this.state = {
      courseCertificate: courseCertificateMap[selectedCourseCertificate.id] ?  _.cloneDeep(courseCertificateMap[selectedCourseCertificate.id]) : {}
      // NOTE: we don't want to change the store, just make changes to a copy
      , formHelpers: {}
      /**
       * NOTE: formHelpers are useful for things like radio controls and other
       * things that manipulate the form, but don't directly effect the state of
       * the courseCertificate
       */
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(courseCertificateActions.fetchSingleIfNeeded(match.params.courseCertificateId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedCourseCertificate, courseCertificateMap } = nextProps;
    this.setState({
      courseCertificate: courseCertificateMap[selectedCourseCertificate.id] ? _.cloneDeep(courseCertificateMap[selectedCourseCertificate.id]) : {}
      //we don't want to actually change the store's courseCertificate, just use a copy
      , formHelpers: {}
    })
  }

  _handleFormChange(e) {
    let newState = _.update( this.state, e.target.name, () => {
      return e.target.value;
    });
    this.setState(newState);
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(courseCertificateActions.sendUpdateCourseCertificate(this.state.courseCertificate)).then((action) => {
      if(action.success) {
        history.push(`/course-certificates/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedCourseCertificate, courseCertificateMap } = this.props;
    const { courseCertificate, formHelpers } = this.state;
    const isEmpty = (!courseCertificate || courseCertificate._id === null || courseCertificate._id === undefined);
    return  (
      <CourseCertificateLayout>
        <Helmet
          title={"Update Certificate | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section">
            {isEmpty ?
              (selectedCourseCertificate.selected.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <CourseCertificateForm
                courseCertificate={courseCertificate}
                cancelLink={`/course-certificates/${courseCertificate._id}`}
                formHelpers={formHelpers}
                formTitle="Update Course Certificate"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
      </CourseCertificateLayout>
    )
  }
}

UpdateCourseCertificate.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedCourseCertificate: store.courseCertificate.selected
    , courseCertificateMap: store.courseCertificate.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateCourseCertificate)
);



// WEBPACK FOOTER //
// modules/courseCertificate/views/UpdateCourseCertificate.js.jsx